import {
  InputSelectControlField,
  TextAreaField,
  TextInputField,
  Flex
} from '@sequencehq/core-components'
import { useProductForm } from './useProductForm'
import { TaxCategoryField } from './TaxCategoryField'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { RevenueRecognitionMethod } from 'common/drawers/PricingEditor/domain'
import { XeroMappingFields } from 'Products/components/XeroMappingFields'
import { PRODUCT_DESCRIPTION_MAX_LENGTH } from 'Products/constants'

export const AddProductForm = () => {
  const {
    fieldsConfig,
    showXeroMappings,
    isXeroMappingsLoading,
    hasXeroMappings
  } = useProductForm()
  const flags = useFeatureFlags()

  return (
    <Flex gap="24px" direction="column" data-testid="priceEditor.addProduct">
      <Flex direction="column" gap="16px">
        <TextInputField
          label="Product name"
          value={fieldsConfig.name.value}
          onChange={e => fieldsConfig.name.onChange(e.target.value)}
          validationErrors={fieldsConfig.name.validationErrors}
          isDisabled={fieldsConfig.name.disabled}
          placeholder="Enter a product name"
          autoFocus
          data-testid="addProduct.name"
        />
        <TextAreaField
          label="Description"
          value={fieldsConfig.label.value}
          onChange={fieldsConfig.label.onChange}
          validationErrors={fieldsConfig.label.validationErrors}
          isDisabled={fieldsConfig.label.disabled}
          placeholder="Enter a product description"
          maxLength={PRODUCT_DESCRIPTION_MAX_LENGTH}
        />

        <TaxCategoryField
          data-testid="addProduct.taxCategoryId"
          field={fieldsConfig.taxCategoryId}
          formChangeset={{}}
        />

        {flags.useRevRec && (
          <InputSelectControlField
            label="Revenue recognition method"
            data-testid="editProduct.revenueRecognitionMethod"
            placeholder="Select method"
            {...fieldsConfig.revenueRecognitionMethod}
            initialValue={fieldsConfig.revenueRecognitionMethod.value}
            onChange={(value: string) => {
              fieldsConfig.revenueRecognitionMethod.onChange(
                value as RevenueRecognitionMethod
              )
            }}
          />
        )}

        {showXeroMappings && !isXeroMappingsLoading && (
          <XeroMappingFields
            deferredField={fieldsConfig.deferredRevenueXeroAccountMappingId}
            recognizedField={fieldsConfig.recognizedRevenueXeroAccountMappingId}
            unbilledField={fieldsConfig.unbilledRevenueXeroAccountMappingId}
            hasMappings={hasXeroMappings}
            testIdPrefix="addProduct"
          />
        )}
      </Flex>
    </Flex>
  )
}
